import { IElement } from "core-integration/src/store/elements/types";
import { ITeam } from "core-integration/src/store/teams/types";
import { ellipsis } from "polished";
import * as React from "react";
import styled from "styled-components";
import Media from "./Media";
import Shirt from "./Shirt";

const MenuButton = styled.button`
  ${ellipsis()};
  width: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  color: inherit;
  font-size: 1.3rem;
  text-align: left;
  cursor: pointer;
`;

const Name = styled.div`
  ${ellipsis()};
`;

const Team = styled.div`
  margin-right: ${({ theme }) => theme.space[2]};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  font-weight: 800;
`;

interface IOwnProps {
  element: IElement;
  renderElementMenu: () => void;
  team: ITeam;
}

type Props = IOwnProps;

const ElementInTable: React.FC<Props> = ({
  element,
  renderElementMenu,
  team,
}) => {
  return (
    <MenuButton onClick={renderElementMenu}>
      <Media img={<Shirt elementId={element.id} />} centred={true}>
        <Name>{element.web_name}</Name>
        <Team>{team.short_name}</Team>
      </Media>
    </MenuButton>
  );
};

export default ElementInTable;
